exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EnL_aA50EmJEnAbTguZyA{margin-bottom:60px}.nJWO6OPc3zsKKP_Maf9Dz{resize:none;border:1px solid #dedede;outline:none;color:#5c5c5c;width:100%;padding:20px;min-height:100px;box-sizing:border-box}.nJWO6OPc3zsKKP_Maf9Dz:focus{outline:none}.nJWO6OPc3zsKKP_Maf9Dz:disabled{color:#8f8f8f;background:#ddd}._3pPqlc0ep7dy1xdDpkZd6Y{float:right;margin-top:15px}\n", ""]);

// Exports
exports.locals = {
	"CommentBox": "EnL_aA50EmJEnAbTguZyA",
	"textarea": "nJWO6OPc3zsKKP_Maf9Dz",
	"submitButton": "_3pPqlc0ep7dy1xdDpkZd6Y"
};